export type AuthModalType = "login" | "register"

function isAuthModalType(modal: string | null): modal is AuthModalType {
  return modal === "login" || modal === "register"
}

/** Whether the current render begins a new auth-modal lifecycle. */
export function didAuthModalJustOpen(wasVisible: boolean, isVisible: boolean): boolean {
  return isVisible && !wasVisible
}

/** Retains the opening modal type while guests switch between auth forms. */
export function getAuthModalInitialType(
  currentModal: string | null,
  currentInitialType: AuthModalType | null,
  nextModal: string | null
): AuthModalType | null {
  if (!isAuthModalType(nextModal)) return null
  return isAuthModalType(currentModal) ? (currentInitialType ?? nextModal) : nextModal
}

/** An auth modal is abandoned only when it closes before authentication completes. */
export function shouldTrackAuthModalDismiss(
  modal: string | null,
  authModalCompleted: boolean
): modal is AuthModalType {
  return isAuthModalType(modal) && !authModalCompleted
}
